<script setup>
import { useAppStore } from '@/stores/app.js'
import { useAuthStore } from '@/stores/auth.js'
import { useUserStore } from '@/stores/user.js'
import { usePaymentStore } from '@/stores/payment'
import LangSwitcherContent from '@/components/ModalContents/LangSwitcherContent.vue'
import Modal from '@/components/Functional/Modal.vue'
// import { computed } from 'vue'
// import { openChatLangSwitcherModal } from '@/helpers/modals.js'
// import helpers from '@/helpers.js'
// import { isWebViewFullCheck } from '@/helpers/is-webview.js'
// import InAppSpy from 'inapp-spy'

// const { isInApp } = InAppSpy(navigator.userAgent)
const appStore = useAppStore()
const authStore = useAuthStore()
const userStore = useUserStore()
const paymentStore = usePaymentStore()

// const paymentMethods = computed(() => {
//   const ids = paymentStore.paymentMethods.map(method => (method.id))
//
//   return ids
// })

function pwaPrompt () {
  if (!appStore.deferredPromptPWAFunc) {
    return
  }

  // Show the prompt
  appStore.deferredPromptPWAFunc.prompt()

  // Wait for the user to respond to the prompt
  appStore.deferredPromptPWAFunc.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === 'accepted') {
      appStore.isPWAInstalled = true
    }

    appStore.deferredPromptPWAFunc = null
  })
}
</script>

<template>
  <!--<pre class="fixed bg-slate-900/70 z-20 text-white right-0 top-0 w-min">{{ checkDomainToShowDebugger() }}</pre>-->

  <div
    v-if="appStore.debugIsOpen"
    class="debug fixed z-10 top-12 right-0 bg-slate-900/70 text-white">
    <div
      class="absolute -top-4 right-0 bg-slate-900/70 h-4 w-4 flex items-center justify-center cursor-pointer"
      @click="appStore.debugIsOpen = false">
      <InlineSvg
        class="w-3 h-3"
        :src="require('@/assets/fontawesome/sharp-solid/xmark-large.svg')"/>
    </div>

    <div class="max-h-[460px] overflow-x-hidden  overflow-y-auto">
      <pre>user: {{ userStore.user?.userId ? userStore.user.userId + ' ' + userStore.user.name : '–' }}</pre>
      <pre>balance: {{ userStore.balance }}</pre>
      <pre>isActive: {{ !!userStore.userIsActive }}</pre>
      <!-- <pre>messageBlur: {{ authStore.options?.messageBlur }}</pre> -->
      <!--<pre>card: {{ paymentStore.purchaseConfig?.currentPaymentMethodId }}</pre>-->
      <!--<pre>card: {{ paymentStore.purchaseConfig }}</pre>-->
      <!--<pre>processorId: {{ paymentStore.paymentProcessor }}</pre>-->
      <!--<pre>taxation: {{ paymentStore.purchaseConfig.defaultTaxation }}</pre>-->
      <!--<pre>trial: {{ paymentStore.trialCreditsForBankCard }}</pre>-->
      <!--<pre>paymentMethods: {{ paymentMethods }}</pre>-->
      <!--<pre>pathBeforeBuying: {{ paymentStore.pathBeforeBuying }}</pre>-->
      <!--<pre>chatTranslationLangSelected: {{ appStore.chatTranslationLangSelected }}</pre>-->
      <!--<pre>chatTransLang: {{ appStore.chatTranslationLang }}</pre>-->
      <!--<pre>isPWAInstalled: {{ appStore.isPWAInstalled }}</pre>-->
      <!--<pre>isWebview: {{ isInApp }}</pre>-->
      <!--<pre>deferredPrompt: {{ !!appStore.deferredPromptPWAFunc }}</pre>-->

      <hr class="my-0.5 border-gray-300">

      <div class="flex">
        <router-link
          to="/test"
          class="btn rounded-none p-0.5 w-1/2 text-white text-sm hover:bg-green-500">
          Test
        </router-link>

        <router-link
          to="/me"
          class="btn rounded-none p-0.5 w-1/2 text-white text-sm hover:bg-green-500">
          Me
        </router-link>

        <button
          type="button"
          class="btn rounded-none p-0.5 w-1/2 text-white text-sm hover:bg-green-500 uppercase"
          @click="$refs.langSwitcher.openModal()">
          {{ $i18n.locale }}
        </button>
      </div>

      <div
        v-if="appStore.deferredPromptPWAFunc"
        class="flex">
        <button
          class="btn rounded-none p-0.5 w-1/2 text-white text-sm hover:bg-green-500"
          @click="pwaPrompt()">
          pwaPrompt
        </button>
      </div>

      <div
        v-if="authStore.isAuthenticated && 1"
        class="flex">
        <button
          type="button"
          :class="{ 'bg-green-400': paymentStore.paymentProcessor === 'stripe' }"
          class="btn rounded-none p-0.5 w-1/2 text-white text-sm"
          @click="paymentStore.selectedPaymentProcessor = 'stripe'">
          Stripe
        </button>

        <button
          type="button"
          :class="{ 'bg-green-400': paymentStore.paymentProcessor === 'exactly' }"
          class="btn rounded-none p-0.5 w-1/2 text-white text-sm"
          @click="paymentStore.selectedPaymentProcessor = 'exactly'">
          Exactly
        </button>
      </div>
    </div>
  </div>

  <Modal
    v-slot="{ closeModal }"
    ref="langSwitcher"
    position="bottom"
    overflow-class="overflow-y-auto"
    rounded-class="rounded-t-2.5xl"
    :has-indents="false"
    name="LangSwitcher">
    <LangSwitcherContent
      ref="langSwitcherContent"
      @close="closeModal()"/>
  </Modal>
</template>
